export const isActive = (links: string[], exactMatch?: boolean, queryString?: string) => {
  const url = window.location.pathname + window.location.search + window.location.hash;
  const urlPathname = window.location.pathname;
  const urlHash = window.location.hash.substring(1);
  const urlQueryString = window.location.search;
  let matchFound = false;

  links.forEach((link) => {
    const toPathname = link.split("#")[0];
    const toHash = link.substring(link.indexOf("#") + 1);
    let queryStringMatch = !urlQueryString || (urlQueryString && queryString === urlQueryString);
    if (!urlQueryString && queryString && urlPathname.indexOf("/integration/extern/") !== -1) {
      queryStringMatch = false;
    }
    matchFound =
      matchFound ||
      Boolean(exactMatch && urlPathname === toPathname && urlHash === toHash && queryStringMatch) ||
      Boolean(!exactMatch && url.indexOf(link) !== -1 && queryStringMatch);
  });
  return matchFound;
};
